"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import { useQueryClient } from "@tanstack/react-query";

import { useSuccessModal } from "@/features/subscriptions/store/use-success-modal";

import {
  Dialog,
  DialogTitle,
  DialogFooter,
  DialogHeader,
  DialogContent,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const SuccessModal = () => {
  const router = useRouter();
  const queryClient = useQueryClient();
  const { isOpen, onClose } = useSuccessModal();

  const handleClose = () => {
    // Invalidate subscription query to refresh the subscription status
    queryClient.invalidateQueries({ queryKey: ["subscription"] });
    router.replace("/");
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader className="flex items-center space-y-4">
          <Image
            src="/favicon.svg"
            alt="Logo"
            width={36}
            height={36}
          />
          <DialogTitle className="text-center">
            구독이 완료되었습니다!
          </DialogTitle>
          <DialogDescription className="text-center">
            서비스 구독이 성공적으로 처리되었습니다
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="pt-2 mt-4 gap-y-2">
          <Button
            className="w-full"
            onClick={handleClose}
          >
            계속하기
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
